export enum TermUseType {
    SERVICE_BOAT_CONTRACT = 'SERVICE_BOAT_CONTRACT',
    MARINA_COMMERCIAL_TERMS = 'MARINA_COMMERCIAL_TERMS'
}